// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"Submit_inputWrapper__dlLAs","submitWrapper":"Submit_submitWrapper__IS3FT","submit":"Submit_submit__AR1gP","glow":"Submit_glow__LSHfY"};